var map = {
	"./IconsDs": [
		1789,
		1789
	],
	"./IconsDs.tsx": [
		1789,
		1789
	],
	"./categoryIcons/SvgArrugas": [
		79279,
		9279
	],
	"./categoryIcons/SvgArrugas.tsx": [
		79279,
		9279
	],
	"./categoryIcons/SvgBody": [
		34118,
		4118
	],
	"./categoryIcons/SvgBody.tsx": [
		34118,
		4118
	],
	"./categoryIcons/SvgCaidaPelo": [
		68666,
		8666
	],
	"./categoryIcons/SvgCaidaPelo.tsx": [
		68666,
		8666
	],
	"./categoryIcons/SvgCalidadPiel": [
		64552,
		4552
	],
	"./categoryIcons/SvgCalidadPiel.tsx": [
		64552,
		4552
	],
	"./categoryIcons/SvgLifting": [
		80390,
		390
	],
	"./categoryIcons/SvgLifting.tsx": [
		80390,
		390
	],
	"./categoryIcons/SvgOtros": [
		34185,
		4185
	],
	"./categoryIcons/SvgOtros.tsx": [
		34185,
		4185
	],
	"./categoryIcons/SvgPelo": [
		56872,
		6872
	],
	"./categoryIcons/SvgPelo.tsx": [
		56872,
		6872
	],
	"./categoryIcons/SvgPiel": [
		97741,
		7741
	],
	"./categoryIcons/SvgPiel.tsx": [
		97741,
		7741
	],
	"./categoryIcons/SvgRelleno": [
		21953,
		1953
	],
	"./categoryIcons/SvgRelleno.tsx": [
		21953,
		1953
	],
	"./dermaIcons/SvgHolaglowDerma": [
		45852,
		5852
	],
	"./dermaIcons/SvgHolaglowDerma.tsx": [
		45852,
		5852
	],
	"./dermaIcons/SvgHolaglowDermaUnicolor": [
		75066,
		5066
	],
	"./dermaIcons/SvgHolaglowDermaUnicolor.tsx": [
		75066,
		5066
	],
	"./designSystemIcons/SvgAdd": [
		73339,
		3339
	],
	"./designSystemIcons/SvgAdd.tsx": [
		73339,
		3339
	],
	"./designSystemIcons/SvgAddFile": [
		59987,
		9987
	],
	"./designSystemIcons/SvgAddFile.tsx": [
		59987,
		9987
	],
	"./designSystemIcons/SvgAngle": [
		16946,
		6946
	],
	"./designSystemIcons/SvgAngle.tsx": [
		16946,
		6946
	],
	"./designSystemIcons/SvgAngleUp": [
		3381,
		3381
	],
	"./designSystemIcons/SvgAngleUp.tsx": [
		3381,
		3381
	],
	"./designSystemIcons/SvgArrow": [
		11783
	],
	"./designSystemIcons/SvgArrow.tsx": [
		11783
	],
	"./designSystemIcons/SvgBad": [
		33905,
		3905
	],
	"./designSystemIcons/SvgBad.tsx": [
		33905,
		3905
	],
	"./designSystemIcons/SvgBag": [
		54780,
		4780
	],
	"./designSystemIcons/SvgBag.tsx": [
		54780,
		4780
	],
	"./designSystemIcons/SvgBox": [
		32310,
		2310
	],
	"./designSystemIcons/SvgBox.tsx": [
		32310,
		2310
	],
	"./designSystemIcons/SvgBoxRemove": [
		31320,
		1320
	],
	"./designSystemIcons/SvgBoxRemove.tsx": [
		31320,
		1320
	],
	"./designSystemIcons/SvgByGoogle": [
		80699,
		699
	],
	"./designSystemIcons/SvgByGoogle.tsx": [
		80699,
		699
	],
	"./designSystemIcons/SvgCalendarAdd": [
		75922,
		5922
	],
	"./designSystemIcons/SvgCalendarAdd.tsx": [
		75922,
		5922
	],
	"./designSystemIcons/SvgCalendarEdit": [
		64492,
		4492
	],
	"./designSystemIcons/SvgCalendarEdit.tsx": [
		64492,
		4492
	],
	"./designSystemIcons/SvgCalendarSearch": [
		21790,
		1790
	],
	"./designSystemIcons/SvgCalendarSearch.tsx": [
		21790,
		1790
	],
	"./designSystemIcons/SvgCalendarTick": [
		68041,
		8041
	],
	"./designSystemIcons/SvgCalendarTick.tsx": [
		68041,
		8041
	],
	"./designSystemIcons/SvgCallIncoming": [
		35498,
		5498
	],
	"./designSystemIcons/SvgCallIncoming.tsx": [
		35498,
		5498
	],
	"./designSystemIcons/SvgCalling": [
		67255,
		7255
	],
	"./designSystemIcons/SvgCalling.tsx": [
		67255,
		7255
	],
	"./designSystemIcons/SvgCancel": [
		9939,
		9939
	],
	"./designSystemIcons/SvgCancel.tsx": [
		9939,
		9939
	],
	"./designSystemIcons/SvgCar": [
		58907,
		8907
	],
	"./designSystemIcons/SvgCar.tsx": [
		58907,
		8907
	],
	"./designSystemIcons/SvgCardPos": [
		44119,
		4119
	],
	"./designSystemIcons/SvgCardPos.tsx": [
		44119,
		4119
	],
	"./designSystemIcons/SvgCart": [
		44449,
		4449
	],
	"./designSystemIcons/SvgCart.tsx": [
		44449,
		4449
	],
	"./designSystemIcons/SvgCd": [
		54548,
		4548
	],
	"./designSystemIcons/SvgCd.tsx": [
		54548,
		4548
	],
	"./designSystemIcons/SvgCheck": [
		68180,
		8180
	],
	"./designSystemIcons/SvgCheck.tsx": [
		68180,
		8180
	],
	"./designSystemIcons/SvgCheckCircle": [
		29074,
		9074
	],
	"./designSystemIcons/SvgCheckCircle.tsx": [
		29074,
		9074
	],
	"./designSystemIcons/SvgCheckSquare": [
		63126,
		3126
	],
	"./designSystemIcons/SvgCheckSquare.tsx": [
		63126,
		3126
	],
	"./designSystemIcons/SvgCheckSquareActive": [
		30890,
		890
	],
	"./designSystemIcons/SvgCheckSquareActive.tsx": [
		30890,
		890
	],
	"./designSystemIcons/SvgConfirm": [
		80113,
		113
	],
	"./designSystemIcons/SvgConfirm.tsx": [
		80113,
		113
	],
	"./designSystemIcons/SvgConfirmed": [
		38425,
		8425
	],
	"./designSystemIcons/SvgConfirmed.tsx": [
		38425,
		8425
	],
	"./designSystemIcons/SvgCream": [
		61025,
		4876
	],
	"./designSystemIcons/SvgCream.tsx": [
		61025,
		4876
	],
	"./designSystemIcons/SvgCross": [
		28309,
		8309
	],
	"./designSystemIcons/SvgCross.tsx": [
		28309,
		8309
	],
	"./designSystemIcons/SvgCrossCircle": [
		60477,
		477
	],
	"./designSystemIcons/SvgCrossCircle.tsx": [
		60477,
		477
	],
	"./designSystemIcons/SvgCrossSquare": [
		86738,
		6738
	],
	"./designSystemIcons/SvgCrossSquare.tsx": [
		86738,
		6738
	],
	"./designSystemIcons/SvgDiamonds": [
		57047,
		7047
	],
	"./designSystemIcons/SvgDiamonds.tsx": [
		57047,
		7047
	],
	"./designSystemIcons/SvgDocument": [
		12349,
		2349
	],
	"./designSystemIcons/SvgDocument.tsx": [
		12349,
		2349
	],
	"./designSystemIcons/SvgDocumentDownload": [
		72107,
		2107
	],
	"./designSystemIcons/SvgDocumentDownload.tsx": [
		72107,
		2107
	],
	"./designSystemIcons/SvgDocumentText": [
		25130,
		5865
	],
	"./designSystemIcons/SvgDocumentText.tsx": [
		25130,
		5865
	],
	"./designSystemIcons/SvgEdit": [
		74852,
		4852
	],
	"./designSystemIcons/SvgEdit.tsx": [
		74852,
		4852
	],
	"./designSystemIcons/SvgEllipsis": [
		53572,
		3572
	],
	"./designSystemIcons/SvgEllipsis.tsx": [
		53572,
		3572
	],
	"./designSystemIcons/SvgEuro": [
		52418,
		1634
	],
	"./designSystemIcons/SvgEuro.tsx": [
		52418,
		1634
	],
	"./designSystemIcons/SvgFileAdded": [
		16624,
		6624
	],
	"./designSystemIcons/SvgFileAdded.tsx": [
		16624,
		6624
	],
	"./designSystemIcons/SvgFilters": [
		17002,
		7002
	],
	"./designSystemIcons/SvgFilters.tsx": [
		17002,
		7002
	],
	"./designSystemIcons/SvgFoam": [
		96299,
		6299
	],
	"./designSystemIcons/SvgFoam.tsx": [
		96299,
		6299
	],
	"./designSystemIcons/SvgGift": [
		49906,
		9906
	],
	"./designSystemIcons/SvgGift.tsx": [
		49906,
		9906
	],
	"./designSystemIcons/SvgGlow": [
		54646,
		3958
	],
	"./designSystemIcons/SvgGlow.tsx": [
		54646,
		3958
	],
	"./designSystemIcons/SvgGood": [
		7395,
		7395
	],
	"./designSystemIcons/SvgGood.tsx": [
		7395,
		7395
	],
	"./designSystemIcons/SvgGoogle": [
		43369,
		3369
	],
	"./designSystemIcons/SvgGoogle.tsx": [
		43369,
		3369
	],
	"./designSystemIcons/SvgHeart": [
		61340,
		1340
	],
	"./designSystemIcons/SvgHeart.tsx": [
		61340,
		1340
	],
	"./designSystemIcons/SvgHolaGlowStar": [
		1905,
		1905
	],
	"./designSystemIcons/SvgHolaGlowStar.tsx": [
		1905,
		1905
	],
	"./designSystemIcons/SvgHolaGlowStar2": [
		15666,
		5666
	],
	"./designSystemIcons/SvgHolaGlowStar2.tsx": [
		15666,
		5666
	],
	"./designSystemIcons/SvgHolaglow": [
		60688,
		688
	],
	"./designSystemIcons/SvgHolaglow.tsx": [
		60688,
		688
	],
	"./designSystemIcons/SvgHome": [
		74571,
		4571
	],
	"./designSystemIcons/SvgHome.tsx": [
		74571,
		4571
	],
	"./designSystemIcons/SvgInfoCircle": [
		28125,
		8125
	],
	"./designSystemIcons/SvgInfoCircle.tsx": [
		28125,
		8125
	],
	"./designSystemIcons/SvgInjection": [
		25685,
		5685
	],
	"./designSystemIcons/SvgInjection.tsx": [
		25685,
		5685
	],
	"./designSystemIcons/SvgLifeBuoy": [
		73832,
		3832
	],
	"./designSystemIcons/SvgLifeBuoy.tsx": [
		73832,
		3832
	],
	"./designSystemIcons/SvgLock": [
		31780,
		1780
	],
	"./designSystemIcons/SvgLock.tsx": [
		31780,
		1780
	],
	"./designSystemIcons/SvgLogin": [
		58498,
		8498
	],
	"./designSystemIcons/SvgLogin.tsx": [
		58498,
		8498
	],
	"./designSystemIcons/SvgLogout": [
		73537,
		3537
	],
	"./designSystemIcons/SvgLogout.tsx": [
		73537,
		3537
	],
	"./designSystemIcons/SvgLogoutv2": [
		49540,
		9540
	],
	"./designSystemIcons/SvgLogoutv2.tsx": [
		49540,
		9540
	],
	"./designSystemIcons/SvgMap": [
		38791,
		8791
	],
	"./designSystemIcons/SvgMap.tsx": [
		38791,
		8791
	],
	"./designSystemIcons/SvgMedal": [
		11289,
		1289
	],
	"./designSystemIcons/SvgMedal.tsx": [
		11289,
		1289
	],
	"./designSystemIcons/SvgMedicine": [
		29051,
		9051
	],
	"./designSystemIcons/SvgMedicine.tsx": [
		29051,
		9051
	],
	"./designSystemIcons/SvgMenu": [
		38933,
		8933
	],
	"./designSystemIcons/SvgMenu.tsx": [
		38933,
		8933
	],
	"./designSystemIcons/SvgMessage": [
		69792,
		9792
	],
	"./designSystemIcons/SvgMessage.tsx": [
		69792,
		9792
	],
	"./designSystemIcons/SvgMinus": [
		70648,
		648
	],
	"./designSystemIcons/SvgMinus.tsx": [
		70648,
		648
	],
	"./designSystemIcons/SvgMonitor": [
		23800,
		3800
	],
	"./designSystemIcons/SvgMonitor.tsx": [
		23800,
		3800
	],
	"./designSystemIcons/SvgMoon": [
		46181,
		6181
	],
	"./designSystemIcons/SvgMoon.tsx": [
		46181,
		6181
	],
	"./designSystemIcons/SvgNoteEdit": [
		18510,
		8510
	],
	"./designSystemIcons/SvgNoteEdit.tsx": [
		18510,
		8510
	],
	"./designSystemIcons/SvgNoteNews": [
		34324,
		4324
	],
	"./designSystemIcons/SvgNoteNews.tsx": [
		34324,
		4324
	],
	"./designSystemIcons/SvgPharmacy": [
		97333,
		7333
	],
	"./designSystemIcons/SvgPharmacy.tsx": [
		97333,
		7333
	],
	"./designSystemIcons/SvgPhone": [
		73976,
		3976
	],
	"./designSystemIcons/SvgPhone.tsx": [
		73976,
		3976
	],
	"./designSystemIcons/SvgPosition": [
		20173,
		173
	],
	"./designSystemIcons/SvgPosition.tsx": [
		20173,
		173
	],
	"./designSystemIcons/SvgRadioChecked": [
		66011,
		6011
	],
	"./designSystemIcons/SvgRadioChecked.tsx": [
		66011,
		6011
	],
	"./designSystemIcons/SvgReagenda": [
		12772,
		2772
	],
	"./designSystemIcons/SvgReagenda.tsx": [
		12772,
		2772
	],
	"./designSystemIcons/SvgReceipt": [
		23042,
		3042
	],
	"./designSystemIcons/SvgReceipt.tsx": [
		23042,
		3042
	],
	"./designSystemIcons/SvgReceipt2": [
		49234,
		9234
	],
	"./designSystemIcons/SvgReceipt2.tsx": [
		49234,
		9234
	],
	"./designSystemIcons/SvgRefresh": [
		26959,
		6959
	],
	"./designSystemIcons/SvgRefresh.tsx": [
		26959,
		6959
	],
	"./designSystemIcons/SvgRefreshSquare": [
		53221,
		3221
	],
	"./designSystemIcons/SvgRefreshSquare.tsx": [
		53221,
		3221
	],
	"./designSystemIcons/SvgRegular": [
		41761,
		1761
	],
	"./designSystemIcons/SvgRegular.tsx": [
		41761,
		1761
	],
	"./designSystemIcons/SvgSad": [
		32739,
		2739
	],
	"./designSystemIcons/SvgSad.tsx": [
		32739,
		2739
	],
	"./designSystemIcons/SvgSadIcon": [
		53776,
		3776
	],
	"./designSystemIcons/SvgSadIcon.tsx": [
		53776,
		3776
	],
	"./designSystemIcons/SvgSearch": [
		15550,
		5550
	],
	"./designSystemIcons/SvgSearch.tsx": [
		15550,
		5550
	],
	"./designSystemIcons/SvgSearchPatient": [
		51846,
		1846
	],
	"./designSystemIcons/SvgSearchPatient.tsx": [
		51846,
		1846
	],
	"./designSystemIcons/SvgSearchStatus": [
		94194,
		4194
	],
	"./designSystemIcons/SvgSearchStatus.tsx": [
		94194,
		4194
	],
	"./designSystemIcons/SvgSecurityUser": [
		47682,
		7682
	],
	"./designSystemIcons/SvgSecurityUser.tsx": [
		47682,
		7682
	],
	"./designSystemIcons/SvgSend": [
		93372,
		3372
	],
	"./designSystemIcons/SvgSend.tsx": [
		93372,
		3372
	],
	"./designSystemIcons/SvgShare": [
		25999,
		5999
	],
	"./designSystemIcons/SvgShare.tsx": [
		25999,
		5999
	],
	"./designSystemIcons/SvgShieldTick": [
		87525,
		7525
	],
	"./designSystemIcons/SvgShieldTick.tsx": [
		87525,
		7525
	],
	"./designSystemIcons/SvgStar": [
		97885,
		7885
	],
	"./designSystemIcons/SvgStar.tsx": [
		97885,
		7885
	],
	"./designSystemIcons/SvgStethoscope": [
		42948,
		2948
	],
	"./designSystemIcons/SvgStethoscope.tsx": [
		42948,
		2948
	],
	"./designSystemIcons/SvgStickyNote": [
		26381,
		4663
	],
	"./designSystemIcons/SvgStickyNote.tsx": [
		26381,
		4663
	],
	"./designSystemIcons/SvgStore": [
		19408,
		9408
	],
	"./designSystemIcons/SvgStore.tsx": [
		19408,
		9408
	],
	"./designSystemIcons/SvgSun": [
		4065,
		4065
	],
	"./designSystemIcons/SvgSun.tsx": [
		4065,
		4065
	],
	"./designSystemIcons/SvgSunGlow": [
		46526,
		6526
	],
	"./designSystemIcons/SvgSunGlow.tsx": [
		46526,
		6526
	],
	"./designSystemIcons/SvgTablet": [
		57795,
		7795
	],
	"./designSystemIcons/SvgTablet.tsx": [
		57795,
		7795
	],
	"./designSystemIcons/SvgTeacher": [
		18417,
		8417
	],
	"./designSystemIcons/SvgTeacher.tsx": [
		18417,
		8417
	],
	"./designSystemIcons/SvgTicket": [
		68152,
		8152
	],
	"./designSystemIcons/SvgTicket.tsx": [
		68152,
		8152
	],
	"./designSystemIcons/SvgTimeLeft": [
		44098,
		4098
	],
	"./designSystemIcons/SvgTimeLeft.tsx": [
		44098,
		4098
	],
	"./designSystemIcons/SvgTimer": [
		87452,
		7452
	],
	"./designSystemIcons/SvgTimer.tsx": [
		87452,
		7452
	],
	"./designSystemIcons/SvgTrash": [
		70581,
		581
	],
	"./designSystemIcons/SvgTrash.tsx": [
		70581,
		581
	],
	"./designSystemIcons/SvgTruehair": [
		78701,
		4007
	],
	"./designSystemIcons/SvgTruehair.tsx": [
		78701,
		4007
	],
	"./designSystemIcons/SvgUpload": [
		96107,
		6107
	],
	"./designSystemIcons/SvgUpload.tsx": [
		96107,
		6107
	],
	"./designSystemIcons/SvgUserOctagon": [
		88150,
		8150
	],
	"./designSystemIcons/SvgUserOctagon.tsx": [
		88150,
		8150
	],
	"./designSystemIcons/SvgUserScan": [
		53486,
		3486
	],
	"./designSystemIcons/SvgUserScan.tsx": [
		53486,
		3486
	],
	"./designSystemIcons/SvgUserSearch": [
		4759,
		4759
	],
	"./designSystemIcons/SvgUserSearch.tsx": [
		4759,
		4759
	],
	"./designSystemIcons/SvgUserSquare": [
		30940,
		940
	],
	"./designSystemIcons/SvgUserSquare.tsx": [
		30940,
		940
	],
	"./designSystemIcons/SvgUsers": [
		86223,
		4365
	],
	"./designSystemIcons/SvgUsers.tsx": [
		86223,
		4365
	],
	"./designSystemIcons/SvgVerify": [
		76003,
		6003
	],
	"./designSystemIcons/SvgVerify.tsx": [
		76003,
		6003
	],
	"./designSystemIcons/SvgVideo": [
		50368,
		368
	],
	"./designSystemIcons/SvgVideo.tsx": [
		50368,
		368
	],
	"./designSystemIcons/SvgWarning": [
		13753,
		3753
	],
	"./designSystemIcons/SvgWarning.tsx": [
		13753,
		3753
	],
	"./designSystemIcons/SvgWhatsapp": [
		74746,
		4746
	],
	"./designSystemIcons/SvgWhatsapp.tsx": [
		74746,
		4746
	],
	"./designSystemIcons/SvgWhatsappAppointment": [
		6106,
		6106
	],
	"./designSystemIcons/SvgWhatsappAppointment.tsx": [
		6106,
		6106
	],
	"./oldIcons/SvgAlma": [
		92593,
		2593
	],
	"./oldIcons/SvgAlma.tsx": [
		92593,
		2593
	],
	"./oldIcons/SvgAngleDown": [
		26858,
		6858
	],
	"./oldIcons/SvgAngleDown.tsx": [
		26858,
		6858
	],
	"./oldIcons/SvgArrowSmallLeft": [
		32090,
		2090
	],
	"./oldIcons/SvgArrowSmallLeft.tsx": [
		32090,
		2090
	],
	"./oldIcons/SvgCalendar": [
		26158,
		6158
	],
	"./oldIcons/SvgCalendar.tsx": [
		26158,
		6158
	],
	"./oldIcons/SvgCheck": [
		49945,
		9945
	],
	"./oldIcons/SvgCheck.tsx": [
		49945,
		9945
	],
	"./oldIcons/SvgCircle": [
		17925,
		7925
	],
	"./oldIcons/SvgCircle.tsx": [
		17925,
		7925
	],
	"./oldIcons/SvgClose": [
		46336,
		6336
	],
	"./oldIcons/SvgClose.tsx": [
		46336,
		6336
	],
	"./oldIcons/SvgCosmetic1": [
		91500,
		1500
	],
	"./oldIcons/SvgCosmetic1.tsx": [
		91500,
		1500
	],
	"./oldIcons/SvgCosmetic2": [
		91219,
		1219
	],
	"./oldIcons/SvgCosmetic2.tsx": [
		91219,
		1219
	],
	"./oldIcons/SvgCosmetic3": [
		33907,
		3907
	],
	"./oldIcons/SvgCosmetic3.tsx": [
		33907,
		3907
	],
	"./oldIcons/SvgCream": [
		6762,
		6762
	],
	"./oldIcons/SvgCream.tsx": [
		6762,
		6762
	],
	"./oldIcons/SvgCreams": [
		96580,
		6580
	],
	"./oldIcons/SvgCreams.tsx": [
		96580,
		6580
	],
	"./oldIcons/SvgDehydration": [
		34577,
		4577
	],
	"./oldIcons/SvgDehydration.tsx": [
		34577,
		4577
	],
	"./oldIcons/SvgDiamond": [
		9267,
		9267
	],
	"./oldIcons/SvgDiamond.tsx": [
		9267,
		9267
	],
	"./oldIcons/SvgDoubleAngleLeft": [
		25516,
		5516
	],
	"./oldIcons/SvgDoubleAngleLeft.tsx": [
		25516,
		5516
	],
	"./oldIcons/SvgEnvelopeOpen": [
		35944,
		5944
	],
	"./oldIcons/SvgEnvelopeOpen.tsx": [
		35944,
		5944
	],
	"./oldIcons/SvgEuroSquare": [
		64369,
		4369
	],
	"./oldIcons/SvgEuroSquare.tsx": [
		64369,
		4369
	],
	"./oldIcons/SvgHairCare": [
		50584,
		584
	],
	"./oldIcons/SvgHairCare.tsx": [
		50584,
		584
	],
	"./oldIcons/SvgHolaglow": [
		12192,
		2192
	],
	"./oldIcons/SvgHolaglow.tsx": [
		12192,
		2192
	],
	"./oldIcons/SvgHolaglowHand": [
		41804,
		1804
	],
	"./oldIcons/SvgHolaglowHand.tsx": [
		41804,
		1804
	],
	"./oldIcons/SvgHour": [
		17441,
		7441
	],
	"./oldIcons/SvgHour.tsx": [
		17441,
		7441
	],
	"./oldIcons/SvgLocation": [
		29815,
		9815
	],
	"./oldIcons/SvgLocation.tsx": [
		29815,
		9815
	],
	"./oldIcons/SvgMapMarker": [
		75783,
		554
	],
	"./oldIcons/SvgMapMarker.tsx": [
		75783,
		554
	],
	"./oldIcons/SvgMedicine": [
		56223,
		6223
	],
	"./oldIcons/SvgMedicine.tsx": [
		56223,
		6223
	],
	"./oldIcons/SvgMoneyReceive": [
		71262,
		1262
	],
	"./oldIcons/SvgMoneyReceive.tsx": [
		71262,
		1262
	],
	"./oldIcons/SvgPepper": [
		82241,
		2241
	],
	"./oldIcons/SvgPepper.tsx": [
		82241,
		2241
	],
	"./oldIcons/SvgPhone": [
		32486,
		2486
	],
	"./oldIcons/SvgPhone.tsx": [
		32486,
		2486
	],
	"./oldIcons/SvgPlusSmall": [
		4714,
		4714
	],
	"./oldIcons/SvgPlusSmall.tsx": [
		4714,
		4714
	],
	"./oldIcons/SvgReceipt": [
		98142,
		8142
	],
	"./oldIcons/SvgReceipt.tsx": [
		98142,
		8142
	],
	"./oldIcons/SvgReceipt2": [
		64807,
		4807
	],
	"./oldIcons/SvgReceipt2.tsx": [
		64807,
		4807
	],
	"./oldIcons/SvgReceiptEdit": [
		35903,
		5903
	],
	"./oldIcons/SvgReceiptEdit.tsx": [
		35903,
		5903
	],
	"./oldIcons/SvgScanQR": [
		16395,
		6395
	],
	"./oldIcons/SvgScanQR.tsx": [
		16395,
		6395
	],
	"./oldIcons/SvgShoppingCart": [
		13033,
		3033
	],
	"./oldIcons/SvgShoppingCart.tsx": [
		13033,
		3033
	],
	"./oldIcons/SvgSkinCare": [
		24354,
		4354
	],
	"./oldIcons/SvgSkinCare.tsx": [
		24354,
		4354
	],
	"./oldIcons/SvgSpinner": [
		19131
	],
	"./oldIcons/SvgSpinner.tsx": [
		19131
	],
	"./oldIcons/SvgStethoscope": [
		19487,
		9487
	],
	"./oldIcons/SvgStethoscope.tsx": [
		19487,
		9487
	],
	"./oldIcons/SvgUserRegular": [
		90411,
		411
	],
	"./oldIcons/SvgUserRegular.tsx": [
		90411,
		411
	],
	"./oldIcons/SvgWorldWideWeb": [
		19678,
		9678
	],
	"./oldIcons/SvgWorldWideWeb.tsx": [
		19678,
		9678
	],
	"./serviceIcons/SvgHilos": [
		21425,
		1425
	],
	"./serviceIcons/SvgHilos.tsx": [
		21425,
		1425
	],
	"./serviceIcons/SvgHydrafacial": [
		29134,
		9134
	],
	"./serviceIcons/SvgHydrafacial.tsx": [
		29134,
		9134
	],
	"./serviceIcons/SvgMicroneedling": [
		20936,
		936
	],
	"./serviceIcons/SvgMicroneedling.tsx": [
		20936,
		936
	],
	"./serviceIcons/SvgMilk": [
		291,
		291
	],
	"./serviceIcons/SvgMilk.tsx": [
		291,
		291
	],
	"./serviceIcons/SvgOndas": [
		88878,
		8878
	],
	"./serviceIcons/SvgOndas.tsx": [
		88878,
		8878
	],
	"./serviceIcons/SvgPrincipiosActivos": [
		87697,
		7697
	],
	"./serviceIcons/SvgPrincipiosActivos.tsx": [
		87697,
		7697
	],
	"./serviceIcons/SvgSolucionQuimica": [
		22221,
		741
	],
	"./serviceIcons/SvgSolucionQuimica.tsx": [
		22221,
		741
	],
	"./socialIcons/SvgExport": [
		77593,
		7593
	],
	"./socialIcons/SvgExport.tsx": [
		77593,
		7593
	],
	"./socialIcons/SvgExport2": [
		82092,
		2092
	],
	"./socialIcons/SvgExport2.tsx": [
		82092,
		2092
	],
	"./socialIcons/SvgFacebook": [
		88655,
		8655
	],
	"./socialIcons/SvgFacebook.tsx": [
		88655,
		8655
	],
	"./socialIcons/SvgInstagram": [
		1880,
		1880
	],
	"./socialIcons/SvgInstagram.tsx": [
		1880,
		1880
	],
	"./socialIcons/SvgTikTok": [
		95429,
		5429
	],
	"./socialIcons/SvgTikTok.tsx": [
		95429,
		5429
	],
	"./socialIcons/SvgX": [
		75915,
		5915
	],
	"./socialIcons/SvgX.tsx": [
		75915,
		5915
	],
	"./suggestionIcons/SvgAgua": [
		62800,
		2800
	],
	"./suggestionIcons/SvgAgua.tsx": [
		62800,
		2800
	],
	"./suggestionIcons/SvgCopa": [
		69145,
		9145
	],
	"./suggestionIcons/SvgCopa.tsx": [
		69145,
		9145
	],
	"./suggestionIcons/SvgCrema": [
		52985,
		2985
	],
	"./suggestionIcons/SvgCrema.tsx": [
		52985,
		2985
	],
	"./suggestionIcons/SvgCross": [
		15476,
		5476
	],
	"./suggestionIcons/SvgCross.tsx": [
		15476,
		5476
	],
	"./suggestionIcons/SvgDental": [
		68294,
		8294
	],
	"./suggestionIcons/SvgDental.tsx": [
		68294,
		8294
	],
	"./suggestionIcons/SvgDeporte": [
		55241,
		5241
	],
	"./suggestionIcons/SvgDeporte.tsx": [
		55241,
		5241
	],
	"./suggestionIcons/SvgEmbarazo": [
		83,
		83
	],
	"./suggestionIcons/SvgEmbarazo.tsx": [
		83,
		83
	],
	"./suggestionIcons/SvgInyeccion": [
		19756,
		9756
	],
	"./suggestionIcons/SvgInyeccion.tsx": [
		19756,
		9756
	],
	"./suggestionIcons/SvgLiquido": [
		6501,
		6501
	],
	"./suggestionIcons/SvgLiquido.tsx": [
		6501,
		6501
	],
	"./suggestionIcons/SvgMaquillaje": [
		14996,
		4996
	],
	"./suggestionIcons/SvgMaquillaje.tsx": [
		14996,
		4996
	],
	"./suggestionIcons/SvgMedicamento": [
		65374,
		5374
	],
	"./suggestionIcons/SvgMedicamento.tsx": [
		65374,
		5374
	],
	"./suggestionIcons/SvgMoto": [
		11818,
		1818
	],
	"./suggestionIcons/SvgMoto.tsx": [
		11818,
		1818
	],
	"./suggestionIcons/SvgNieve": [
		66177,
		6177
	],
	"./suggestionIcons/SvgNieve.tsx": [
		66177,
		6177
	],
	"./suggestionIcons/SvgNoCrema": [
		69894,
		9894
	],
	"./suggestionIcons/SvgNoCrema.tsx": [
		69894,
		9894
	],
	"./suggestionIcons/SvgReposo": [
		6554,
		6554
	],
	"./suggestionIcons/SvgReposo.tsx": [
		6554,
		6554
	],
	"./suggestionIcons/SvgSauna": [
		71818,
		6613
	],
	"./suggestionIcons/SvgSauna.tsx": [
		71818,
		6613
	],
	"./suggestionIcons/SvgSol": [
		77424,
		7424
	],
	"./suggestionIcons/SvgSol.tsx": [
		77424,
		7424
	],
	"./suggestionIcons/SvgTacto": [
		3460,
		3460
	],
	"./suggestionIcons/SvgTacto.tsx": [
		3460,
		3460
	],
	"./suggestionIcons/SvgTextura": [
		36706,
		6706
	],
	"./suggestionIcons/SvgTextura.tsx": [
		36706,
		6706
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 82150;
module.exports = webpackAsyncContext;